import {VuexModule, Module, getModule, MutationAction, Action, Mutation} from 'vuex-module-decorators';

import store from '@/store';
import {User as UserModel} from '@/store/models';
import UserService from '@/services/UserService';
import router from '@/router';

@Module({
    dynamic: true,
    store,
    name: 'user'
})
class User extends VuexModule {
    public user: UserModel | null = null;
    public token: string = '';
    public tokenType?: string = undefined;
    public expiresIn?: number = 0;
    public loggedIn: boolean = false;

    /**
     * Load User data.
     *
     * @param userId
     */
    @MutationAction
    public async loadUser() {
        const user = await UserService.getInstance().getUser();
        return {user};
    }

    get accessToken() {
        let token: string | null = this.token;
        if (token === '') {
            token = localStorage.getItem('accessToken');
        }
        return token;
    }

    get userId(): number {
        return (this.user && this.user.id) ? this.user.id : 0;
    }

    get surveyFinished() {
        return this.user ? this.user.survey_finished : true;
    }

    @Action
    public async isLoggedIn(): Promise<boolean> {
        try {
            const response = await UserService.getInstance().getUser();
            const authorized = response !== 401 ? true : false;
            this.setLoggedIn(authorized);

            return this.loggedIn;
        } catch (ex) {
            return false;
        }
    }

    /**
     * Save user data.
     */
    @MutationAction
    public async saveUser(updatedUser: UserModel) {
        // TODO error handling
        const user = await UserService.getInstance().saveUser(updatedUser);
        return {user};
    }

    @Mutation
    public setAccessToken(accessToken: string) {
        localStorage.accessToken = accessToken;
        this.token = accessToken;
    }

    @Mutation
    public setUser(user: UserModel | null) {
        this.user = user;
    }

    @Mutation
    public setTokenType(tokenType: string) {
        this.tokenType = tokenType;
    }

    @Mutation
    public setExpiresIn(expiresIn: number) {
        this.expiresIn = expiresIn;
    }

    @Mutation
    public setLoggedIn(status: boolean) {
        this.loggedIn = status;
    }

    @Mutation
    public setCertificatePrinted(status: boolean) {
        if (this.user) {
            this.user.certificate_printed = status;
        }
    }

    @Mutation
    public setSurveyFinished(status: boolean) {
        if (this.user) {
            this.user.survey_finished = status;
        }
    }

    @Action
    public async loginUser(token: string): Promise<any> {
        try {
            const response = await UserService.getInstance().loginUser(token);
            const userResponse = response.data;
            if (userResponse.access_token) {
                // Set instance values
                this.setUser(userResponse.user);
                this.setAccessToken(userResponse.access_token);
                this.setTokenType(userResponse.token_type);
                this.setExpiresIn(userResponse.expires_in);
                this.setLoggedIn(true);
                this.setCertificatePrinted(userResponse.certificate_printed);
                this.setCertificatePrinted(userResponse.certificatePrinted);

                router.push({name: 'profile'});
            }
        } catch (ex) {
            return ex;
        }
    }

    @Action
    public logOutUser() {
        UserService.getInstance().logOutUser();
        this.setAccessToken('');
        this.setUser(null);
        this.setLoggedIn(false);
        router.push({name: 'login'});
    }
}

export const UserModule = getModule(User);
